(function () {
  var MIN_THUMB = 32;

  function initSlider(root) {
    if (!root || root.dataset.sliderReady === 'true') return;
    var track = root.querySelector('.listicle-products__track');
    var progress = root.querySelector('.listicle-products__progress');
    var thumb = root.querySelector('.listicle-products__progress-thumb');
    if (!track || !progress || !thumb) return;
    root.dataset.sliderReady = 'true';

    function maxScroll() {
      return track.scrollWidth - track.clientWidth;
    }

    function updateThumb() {
      var ms = maxScroll();
      var pw = progress.clientWidth;
      if (ms <= 1) {
        progress.style.visibility = 'hidden';
        return;
      }
      progress.style.visibility = 'visible';
      var tw = Math.max(pw * (track.clientWidth / track.scrollWidth), MIN_THUMB);
      var left = (track.scrollLeft / ms) * (pw - tw);
      thumb.style.width = tw + 'px';
      thumb.style.transform = 'translateX(' + left + 'px)';
    }

    track.addEventListener('scroll', updateThumb, { passive: true });
    window.addEventListener('resize', updateThumb);
    window.addEventListener('load', updateThumb);

    /* ---- Drag-to-scroll on the track (desktop mouse) ---- */
    var dragging = false, startX = 0, startScroll = 0, moved = false;

    track.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      dragging = true;
      moved = false;
      startX = e.pageX;
      startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
      e.preventDefault(); /* stop text/image selection */
    });
    document.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 3) moved = true;
      track.scrollLeft = startScroll - dx;
    });
    document.addEventListener('mouseup', function () {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
    });
    /* Swallow the click that follows a real drag so links don't fire. */
    track.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);

    /* ---- Drag the progress thumb like a scrollbar ---- */
    var thumbDrag = false, thumbStartX = 0, thumbStartScroll = 0;

    function thumbDown(e) {
      thumbDrag = true;
      thumbStartX = e.pageX != null ? e.pageX : e.touches[0].pageX;
      thumbStartScroll = track.scrollLeft;
      e.preventDefault();
      e.stopPropagation();
    }
    function thumbMove(e) {
      if (!thumbDrag) return;
      var px = e.pageX != null ? e.pageX : e.touches[0].pageX;
      var travel = progress.clientWidth - thumb.offsetWidth;
      if (travel <= 0) return;
      track.scrollLeft = thumbStartScroll + ((px - thumbStartX) / travel) * maxScroll();
    }
    function thumbUp() {
      thumbDrag = false;
    }

    thumb.addEventListener('mousedown', thumbDown);
    document.addEventListener('mousemove', thumbMove);
    document.addEventListener('mouseup', thumbUp);
    thumb.addEventListener('touchstart', thumbDown, { passive: false });
    document.addEventListener('touchmove', thumbMove, { passive: false });
    document.addEventListener('touchend', thumbUp);

    updateThumb();
  }

  function initAll(context) {
    (context || document).querySelectorAll('.listicle-products').forEach(initSlider);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
